export default __webpack_public_path__ + "static/GASTOS_MÉDICOS-f5c446fe781c2d4cfb61bade6fd3cdac.png";